import { Component, Input, OnInit } from '@angular/core';
import {NgbAlertConfig} from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core';
import { Message } from '../../../services/api-services/api-interfaces/message.interface';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.sass'],
    standalone: false
})
export class AlertComponent implements OnInit {
  @Input() type: any = {}
  @Input() Message: any = {}
  constructor(
    private configAlert:NgbAlertConfig,
    private translate: TranslateService,
  ) {
    configAlert.dismissible=false;
  }


  ngOnInit(): void {
    // console.log(this.Message,this.type);

  }

}
